type HookProps = {
    variant: string;
    blockTitle: string;
    nodeTitle: string;
    nodePropmpt: string;
    preferedNodeName: string;
    isNodeConfigured: boolean;
};

// copied from useIVRBlockData
// TODO:  once we have this in all the journey blocks
// consolidate on one block hook
export function useJourneyBlockData({
    variant,
    blockTitle,
    nodeTitle,
    nodePropmpt,
    preferedNodeName,
    isNodeConfigured,
}: HookProps) {
    const isBlock = variant === "block";

    const fallBackTitle = isBlock ? blockTitle : nodeTitle;
    const isActive = isBlock || isNodeConfigured;
    const nodeName = !isBlock ? (isNodeConfigured ? preferedNodeName : nodePropmpt) : nodeTitle;

    return {
        isActive,
        isBlock,
        fallBackTitle,
        nodeName,
    };
}
